module.exports = __webpack_public_path__ + "assets/funil.6f5cdae7.svg";